import styled from 'styled-components';

import { spaceL } from '@xingternal/tokens';

export const SimilarJobWrapper = styled.div`
  margin: ${spaceL} 0;
`;
